import React, { useEffect, useState } from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { getGuestVariantCookie } from 'services/guest';
import m from '../messages';

const NAME_INPUT_MAX_LENGTH = 36; // this should keep inputs from being greater than 2 lines

const InputFields = ({ values, isInvalidName, isInvalidEmail, intl }) => {
    const [variant, setVariant] = useState(null);
    const [preplanningMessage, setPreplanningMessage] = useState(m.preplanningA);

    useEffect(() => {
        setVariant(getGuestVariantCookie());
    }, []);

    useEffect(() => {
        setPreplanningMessage(variant === 'B' ? m.preplanningB : m.preplanningA);
    }, [variant]);

    return (
        <>
            {/* <span className="placeholder placeholder-upper">
                <FormattedMessage id="firstAndLastName" defaultMessage="First and Last Name" />
            </span> */}
            <Field
                name="name"
                className={`guest-form-input ${isInvalidName ? 'invalid' : ''}`}
                maxLength={NAME_INPUT_MAX_LENGTH}
                placeholder={intl.formatMessage({
                    id: 'firstAndLastName',
                    defaultMessage: 'First and Last Name',
                })}
            />
            {values.name.length >= NAME_INPUT_MAX_LENGTH && (
                <span className="field-error-message">
                    <FormattedMessage
                        id="features.Viewlogy.GuestSection.Form.inputTooLong"
                        defaultMessage="Input must be 36 characters or less."
                    />
                </span>
            )}
            {/* <span className="placeholder placeholder-upper">
                <FormattedMessage id="email" defaultMessage="Email" />
            </span> */}
            <Field
                name="email"
                type="email"
                className={`guest-form-input ${isInvalidEmail ? 'invalid' : ''}`}
                placeholder={intl.formatMessage({ id: 'email', defaultMessage: 'Email' })}
            />
            <div className="checkbox-formatter">
                <span className="placeholder">
                    <FormattedMessage id="preplanningInterest" defaultMessage={preplanningMessage} />
                </span>
                <Field name="preplanningInterest" type="checkbox" />
            </div>
        </>
    );
};

export default InputFields;
